import Regiao from '../../spa/regiao/RegiaoCadastro';

export default {
  path: 'regiao',
  name: 'regiao',
  component: Regiao,
};
